import ClsServices from '../ws/cls-services';
import TrackingAction from '../constants/tracking-action';
import JmServices from '../ws/jm-services';

class EmailRepository {
    constructor() {
        this.existingEmailCache = {};
        this.federatedEmailCache = {};
    }

    isEmailExisting(componentId, email) {
        if (this.existingEmailCache[email] !== undefined) {
            return Promise.resolve(this.existingEmailCache[email]);
        }

        return ClsServices.isEmailExisting(componentId, {email: email})
            .then(response => {

                if (response.exists) {
                    JmServices.trackEvent(componentId, { trackingValue: TrackingAction.jlsTypedAlreadyExistingEmail });
                }

                this.existingEmailCache[email] = { 'exists': response.exists, 'hasPassword': response.has_password};
                return this.existingEmailCache[email];
            });
    }

    isEmailFederated(componentId, email) {
        if (this.federatedEmailCache[email] !== undefined) {
            return Promise.resolve(this.federatedEmailCache[email]);
        }

        return ClsServices.isEmailFederated(componentId, {email: email})
            .then(response => {

                if (response.federated_auth_required) {
                    JmServices.trackEvent(componentId, { trackingValue: TrackingAction.jlsTypedFederatedEmail });
                }

                this.federatedEmailCache[email] = response.federated_auth_required;
                return this.federatedEmailCache[email];
            });
    }
}

export default new EmailRepository();



/** WEBPACK FOOTER **
 ** ./src/logic/email-repository.js
 **/